// features/search/searchApiSlice.js
import { apiSlice } from "../../app/api/apiSlice";

export const searchApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    searchProperties: builder.query({
      query: (searchParams) => {
        // Build query params from search parameters
        const params = new URLSearchParams();

        // 1. If we have a suggestion ID (most precise)
        if (searchParams?.suggestionId) {
          params.append("suggestionId", searchParams.suggestionId);
        }
        if (searchParams?.cityId) params.append("cityId", searchParams.cityId);
        if (searchParams?.q || searchParams?.query)
          params.append("q", searchParams.q || searchParams.query);

        // // 2. Location (Optional, if you use precise lat/lng or cityId)
        // if (searchParams?.cityId) params.append("cityId", searchParams.cityId);

        // // 2. If we have title and location from suggestion
        // else if (searchParams?.title && searchParams?.location) {
        //   params.append("title", searchParams.title);
        //   params.append("location", searchParams.location);
        // }
        // // 3. If we have a regular query string
        // else if (searchParams?.query) {
        //   params.append("q", searchParams.query);
        // }
        // // 4. If query is an object (from suggestion)
        // else if (
        //   typeof searchParams?.query === "object" &&
        //   searchParams.query?.title
        // ) {
        //   params.append("title", searchParams.query.title);
        //   params.append("location", searchParams.query.location);
        //   if (searchParams.query.id) {
        //     params.append("suggestionId", searchParams.query.id);
        //   }
        // }

        // Other filter parameters
        if (searchParams?.minPrice) {
          params.append("minPrice", searchParams.minPrice);
        }
        if (searchParams?.maxPrice) {
          params.append("maxPrice", searchParams.maxPrice);
        }
        // if (searchParams?.bedrooms) {
        //   params.append("bedrooms", searchParams.bedrooms);
        // }
        // if (searchParams?.bathrooms) {
        //   params.append("bathrooms", searchParams.bathrooms);
        // }

        if (searchParams?.gender) params.append("gender", searchParams.gender);
        if (searchParams?.tenantType)
          params.append("tenantType", searchParams.tenantType);
        if (searchParams?.sharingType)
          params.append("sharingType", searchParams.sharingType);
        if (searchParams?.bathroomType)
          params.append("bathroomType", searchParams.bathroomType);

        // if (searchParams?.propertyType) {
        //   params.append("propertyType", searchParams.propertyType);
        // }
        if (searchParams?.amenities?.length) {
          params.append("amenities", searchParams.amenities.join(","));
        }

        // Pagination parameters
        if (searchParams?.page) {
          params.append("page", searchParams.page);
        }
        if (searchParams?.limit) {
          params.append("limit", searchParams.limit);
        }

        // console.log("Search API params:", params.toString());

        return {
          url: `/properties/search?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Search"],
      transformResponse: (response) => response.data || response,
      // Optional: Cache the results for 5 minutes
      keepUnusedDataFor: 120,
    }),

    // Optional: Get search suggestions
    getSearchSuggestions: builder.query({
      query: (query) => `/properties/suggestions?q=${query}`,
      transformResponse: (response) => response.data || response,
      // Cache suggestions for 1 minute
      keepUnusedDataFor: 60,
    }),

    // Optional: Get property details for map markers
    getPropertiesForMap: builder.query({
      query: ({ bounds, filters = {} }) => {
        const params = new URLSearchParams();

        // Add map bounds if available
        if (bounds) {
          params.append("neLat", bounds.northEast.lat);
          params.append("neLng", bounds.northEast.lng);
          params.append("swLat", bounds.southWest.lat);
          params.append("swLng", bounds.southWest.lng);
        }

        // Add filters
        if (filters.minPrice) params.append("minPrice", filters.minPrice);
        if (filters.maxPrice) params.append("maxPrice", filters.maxPrice);
        if (filters.propertyType)
          params.append("propertyType", filters.propertyType);

        return {
          url: `/properties/map?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Search"],
      transformResponse: (response) => response.data || response,
    }),
  }),
});

// Export hooks for usage in components
export const {
  useSearchPropertiesQuery,
  useLazySearchPropertiesQuery,
  useGetSearchSuggestionsQuery,
  useLazyGetSearchSuggestionsQuery,
  useGetPropertiesForMapQuery,
  useLazyGetPropertiesForMapQuery,
} = searchApiSlice;
